import { Heading } from '@ctw/shared/components/heading';
import { DOCUMENT_VIEWER_HEADING_TEST_ID } from '@ctw/shared/test/ids';
import { effectiveHeadingLevel } from '@ctw/shared/utils/cda/heading-level';
import { isParsedTextNode, uniqueIdentifierForNode } from '@ctw/shared/utils/cda/helpers';
import type { CdaParsedHtmlElementNode } from '@ctw/shared/utils/cda/types';
import { twx } from '@ctw/shared/utils/tailwind';
import { memo } from 'react';
import { ReactNodeRenderer } from './react-node-renderer';

interface HeadingRendererProps {
  id: string;
  heading: CdaParsedHtmlElementNode;
}

export const ReactHeadingRenderer = memo(({ id, heading }: HeadingRendererProps) => {
  const childrenIsSoloTextElement =
    heading.childNodes.length === 1 && isParsedTextNode(heading.childNodes[0]);

  return (
    <Heading
      key={id}
      level={effectiveHeadingLevel(heading.nodeName)}
      testId={DOCUMENT_VIEWER_HEADING_TEST_ID}
      className={twx(heading.styles.className)}
      dataSearchIndex={heading.searchIndexId ?? undefined}
    >
      {childrenIsSoloTextElement &&
        isParsedTextNode(heading.childNodes[0]) &&
        heading.childNodes[0].textContent}
      {!childrenIsSoloTextElement &&
        heading.childNodes.map((child, index) => {
          const headingChildIdentifier = uniqueIdentifierForNode({
            node: child,
            context: id,
            purpose: 'heading-child',
            index,
          });

          return (
            <ReactNodeRenderer
              key={headingChildIdentifier}
              id={headingChildIdentifier}
              node={child}
            />
          );
        })}
    </Heading>
  );
});
